export default {
  name: "InputPhoneComponent",
  props: ['modelValue'],
  emits: ['update:modelValue'],
  watch: {
    modelValue: function (newValue) {
      this.$emit('update:modelValue', newValue.replace(/[^\d\-+]/, ""));
    }
  }
};